import styled from 'styled-components/macro'
export const EntryContentWrapper = styled.div`
    font-weight: 500;

    * {
        font-size: 12px;
    }
`